module.exports = __webpack_public_path__ + "static/simufact0A-c4896d0919d05a0e5568a0a4d20de6f5.jpg";